import React from 'react';
import Chart from 'react-apexcharts';
import { Card, Box } from '@mui/material';

const StackedBarChart = ({ title, series, categories, }) => {
  const chartOptions = {
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      toolbar: {
        show: true,
        tools: { download: true, selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false },
      },
      animations: {
        enabled: true,
        easing: 'easeout',
        speed: 800,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true, // Horizontal stacked bar
        barHeight: '80%',
        borderRadius: 6,
      },
    },
    colors: ['#14b8a6', '#2dd4bf', '#5eead4', '#99f6e4', '#ccfbf1'], // Teal palette
    dataLabels: {
      enabled: true,
      formatter: (val) => val.toLocaleString(),
      style: {
        fontSize: '12px',
        fontFamily: "'Inter', sans-serif",
        colors: ['#1e293b'],
      },
      offsetX: 30,
    },
    xaxis: {
      categories: ['Followers'], // Single category for stacked bar
      labels: {
        style: { fontSize: '12px', fontFamily: "'Inter', sans-serif", fontWeight: 500, colors: '#64748b' },
        formatter: (val) => val.toLocaleString(),
      },
    },
    yaxis: {
      labels: {
        style: { fontSize: '12px', fontFamily: "'Inter', sans-serif", fontWeight: 500, colors: '#64748b' },
      },
    },
    tooltip: {
      theme: 'dark',
      style: { fontSize: '12px', fontFamily: "'Inter', sans-serif" },
      y: {
        formatter: (val, { seriesIndex }) => `${categories[seriesIndex]}: ${val.toLocaleString()} followers`,
      },
    },
    title: {
      text: `${title}`,
      align: 'center',
      style: { fontSize: '18px', fontFamily: "'Inter', sans-serif", fontWeight: 600, color: '#1e293b' },
    },
    legend: {
      show: true,
      position: 'bottom',
      fontSize: '12px',
      fontFamily: "'Inter', sans-serif",
      fontWeight: 500,
      labels: { colors: '#1e293b' },
    },
    grid: {
      borderColor: 'rgba(203, 213, 225, 0.3)',
      strokeDashArray: 5,
    },
  };

  const chartSeries = categories.map((category, index) => ({
    name: category,
    data: [series[0].data[index]], // One data point per age group
  }));

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        minHeight: '400px',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        borderRadius: '12px',
        backgroundColor: '#ecfdf5', // Light teal background
      }}
    >
      <Box sx={{ width: '100%', height: '100%' }}>
        <Chart options={chartOptions} series={chartSeries} type="bar" height="100%" />
      </Box>
    </Card>
  );
};

export default StackedBarChart;